import { render, staticRenderFns } from "./ViewAllTemplate.vue?vue&type=template&id=cbcec31a&"
import script from "./ViewAllTemplate.vue?vue&type=script&lang=js&"
export * from "./ViewAllTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllTemplate.vue?vue&type=style&index=0&id=cbcec31a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports